import { Subscription } from 'rxjs';

export function AutoUnsubscribe(instance: any) {
  instance.prototype.ngOnDestroy = decorateOnDestroy(instance.prototype.ngOnDestroy);
}

export function decorateOnDestroy(originalDestroy: (() => void) | null | undefined) {
  return function (this: any) {
    originalDestroy && originalDestroy.call(this);

    for (const propertyName in this) {
      if (Array.isArray(this[propertyName])) {
        this[propertyName].forEach((element: any) => unsubscribe(element, this.constructor.name, propertyName));
      } else {
        unsubscribe(this[propertyName], this.constructor.name, propertyName);
      }
    }
  };
}

export function unsubscribe(property: any, constructorName: string, propertyName: string): void {
  if (property instanceof Subscription && !property.closed) {
    try {
      property.unsubscribe();
    } catch (error: any) {
      console.warn(`Could not unsubscribe ${constructorName}.${propertyName}`);
      console.warn(error);
    }
  }
}
